import { webPortalApi } from '#config/web-portal-api';
import { snackBarError } from '#action/fetch';
import { getDateRangeWithSessionFallback } from '#component/general/date-range/helper';
import {
  FETCH_USER_LOGS,
  FETCH_USER_LOGS_STARTED,
  FETCH_USER_LOGS_FAILED,
  USER_LOGS_PAGINATED_CHANGE_PAGE,
  USER_LOGS_CHANGE_ORDER,
  USER_LOGS_CLEAR
} from '#action/types';
import { getRequestOptions, getDateRange, getURLParameter, setIdsParam } from '#helper';

let abortController = new AbortController();

export const fetchUserLogs = () => async (dispatch, getState) => {
  try {
    abortController.abort();

    dispatch({
      type: FETCH_USER_LOGS_STARTED
    });

    const filter = getState().listFilter;
    const sourcePath = 'user-log';
    const logFilter = filter[sourcePath];
    const { page, itemsPerPage, order } = getState().userLog;
    const urlPage = getURLParameter('page');
    const offset = (Number(urlPage || page) - 1) * itemsPerPage;
    const searchParams = new URLSearchParams({
      order,
      offset,
      limit: 50
    });
    const projectValue = logFilter?.project?.value;
    const actorValue = logFilter?.user?.value;
    const targetUserValue = logFilter?.targetUser?.value;
    const { start: dateRangeStart, end: dateRangeEnd } = getDateRangeWithSessionFallback(
      logFilter?.start?.value,
      logFilter?.end?.value
    );
    const eventValue = logFilter?.event?.value;
    setIdsParam(searchParams, 'project', projectValue);
    setIdsParam(searchParams, 'user', actorValue);
    setIdsParam(searchParams, 'targetUser', targetUserValue);
    setIdsParam(searchParams, 'event', eventValue);

    if (dateRangeStart && dateRangeEnd) {
      const range = getDateRange(dateRangeStart, dateRangeEnd);
      searchParams.set('start', range.start);
      searchParams.set('end', range.end);
    }

    abortController = new AbortController();
    const { signal } = abortController;
    // Debounce to do not send multiple requests in short time
    await new Promise(res => {
      setTimeout(() => {
        res();
      }, 200);
    });
    const url = webPortalApi.buildApiUrl(`user/log?${searchParams.toString()}`);
    const res = await fetch(url, { ...getRequestOptions(), signal });
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }
    if (!res.ok) {
      const response = await res.json();
      dispatch({
        type: FETCH_USER_LOGS_FAILED,
        error: response
      });
      return dispatch(
        snackBarError({
          message: 'Error in request',
          ...response
        })
      );
    }

    const { logs = [], last } = await res.json();

    return dispatch({
      type: FETCH_USER_LOGS,
      totalCount: last,
      payload: logs
    });
  } catch (e) {
    if (e.name === 'AbortError') {
      return false;
    }
    return dispatch({
      type: FETCH_USER_LOGS_FAILED,
      error: e
    });
  }
};

export const changeOrder = (newOrder, { refetch = true } = {}) => dispatch => {
  dispatch({
    type: USER_LOGS_CHANGE_ORDER,
    payload: newOrder
  });

  if (refetch) {
    dispatch(fetchUserLogs());
  }
};

export const changePage = (newPage, { refetch = true } = {}) => dispatch => {
  dispatch({
    type: USER_LOGS_PAGINATED_CHANGE_PAGE,
    payload: newPage
  });

  if (refetch) {
    dispatch(fetchUserLogs());
  }
};

export const clear = () => dispatch => {
  abortController.abort();
  dispatch({
    type: USER_LOGS_CLEAR
  });
};
